export const ADD_EMPLOYEE = "enter_ages/ADD_EMPLOYEE";
export const ADD_SPOUSE = "enter_ages/ADD_SPOUSE";
export const REMOVE_EMPLOYEE = "enter_ages/REMOVE_EMPLOYEE";
export const REMOVE_SPOUSE = "enter_ages/REMOVE_SPOUSE";
export const ADD_CHILD = "enter_ages/ADD_CHILD";
export const REMOVE_CHILD = "enter_ages/REMOVE_CHILD";
export const UPDATE_CHILD_AGE = "enter_ages/UPDATE_CHILD_AGE";
export const UPDATE_EMPLOYEE_AGE = "enter_ages/UPDATE_EMPLOYEE_AGE";
export const UPDATE_SPOUSE_AGE = "enter_ages/UPDATE_SPOUSE_AGE";
export const VALIDATE_EMPLOYEE_PROFILE = "enter_ages/VALIDATE_EMPLOYEE_PROFILE";
export const PERSIST_EMPLOYEE_PROFILE = "enter_ages/PERSIST_EMPLOYEE_PROFILE";
export const UPDATE_OVERALL_ERROR_MESSAGE = "enter_ages/UPDATE_OVERALL_ERROR_MESSAGE";
export const REPLACE_EMPLOYEE_PROFILE = "enter_ages/REPLACE_EMPLOYEE_PROFILE";
export const ALL_CHANGE_ACTIONS = [
  ADD_EMPLOYEE,
  ADD_SPOUSE,
  REMOVE_EMPLOYEE,
  REMOVE_SPOUSE,
  ADD_CHILD,
  REMOVE_CHILD,
  UPDATE_CHILD_AGE,
  UPDATE_EMPLOYEE_AGE,
  UPDATE_SPOUSE_AGE,
  REPLACE_EMPLOYEE_PROFILE,
];
